import { useRef } from 'react';
import { useDispatch } from 'react-redux';
import { SidePanel } from '@mews/b2b-ui';
import { Container, IconName } from '@optimus-web/core';
import { TooltippedIconButton } from '@mews-commander/ui';
import { lt } from '@mews/framework';
import { useResolveRoute } from '@mews/routing';
import { RouteName } from '@mews-commander/enums';
import { DEFAULT_PORTAL_ID } from '@mews-commander/constants';
import { CorrectionBillDetailContent } from '../CorrectionBillDetailContent';
import { openModal } from '../../../app/actions/common';
import { useCorrectionDetail } from '../../hooks/useCorrectionDetail';

interface BillDetailSidePanelProps {
    billId: string;
    opened: boolean;
    closeDialog: () => void;
}

export const BillDetailSidePanel = ({ billId, opened, closeDialog }: BillDetailSidePanelProps) => {
    const dispatch = useDispatch();

    const ref = useRef<HTMLDivElement | null>(null);

    const { data, isFetching } = useCorrectionDetail({ correctionBillId: billId, enabled: opened });

    const resolveRoute = useResolveRoute();

    const onActionLogClick = (e: React.MouseEvent) => {
        e.preventDefault();
        const url = resolveRoute(RouteName.BillActionLog, { id: billId });
        return dispatch(openModal(url));
    };

    return (
        <SidePanel
            title={data?.correctiveBill?.name}
            onClose={closeDialog}
            width="medium"
            headerActions={
                <TooltippedIconButton
                    tooltip={lt('ViewActionLog')}
                    variant="tertiary"
                    size="medium"
                    icon={IconName.ActionLog}
                    onClick={onActionLogClick}
                    type="button"
                />
            }
            content={
                <Container ref={ref}>
                    <CorrectionBillDetailContent billId={billId} />
                </Container>
            }
            loading={isFetching}
            opened={opened}
            portalContainerId={DEFAULT_PORTAL_ID}
        />
    );
};
